import type { SubscriptionInfo } from '@/hooks/use-subscription'

export type FeatureKey = 'scanner_ai' | 'recurring_checklist' | 'csv_export' | 'unlimited_transactions' | 'ai_coach'

export function getTrialFallbackUntil(): number | null {
  try {
    const raw = sessionStorage.getItem('pw_trial_fallback_until')
    if (!raw) return null
    const ts = parseInt(raw, 10)
    return Number.isFinite(ts) ? ts : null
  } catch {
    return null
  }
}

export function isTrialActive(sub: SubscriptionInfo | null | undefined): boolean {
  // Use only server-backed info computed in useSubscription (based on trial_end)
  return !!sub?.trialActive
}

export function hasFeature(feature: FeatureKey, sub: SubscriptionInfo | null | undefined): boolean {
  const plan = sub?.plan
  const isPro = plan === 'pro'
  const isPlus = plan === 'plus'
  const isFree = plan === 'free' || !plan // No plan = free tier
  const trial = isTrialActive(sub)

  switch (feature) {
    case 'scanner_ai':
      return isPro || trial
    case 'ai_coach':
      return isPro || trial
    case 'recurring_checklist':
      return isPlus || isPro || trial
    case 'csv_export':
      return isPlus || isPro || trial
    case 'unlimited_transactions':
      return isPlus || isPro || trial
    default:
      return false
  }
}

// Free tier limits
export const FREE_TIER_LIMITS = {
  MAX_TRANSACTIONS_PER_MONTH: 50,
  MAX_CATEGORIES: 10,
}

export function getPlanDisplayName(plan: string | null | undefined): string {
  switch (plan) {
    case 'pro': return 'Pro'
    case 'plus': return 'Plus'
    case 'free': return 'Free'
    default: return 'Free'
  }
}
